export const ALL_STATES = -1;
export const ALL_USERS = -1;
export const ALL_PAYMENT_TYPES = -1;
